<template>
    <div class="dropdown" @click.stop="toggleDropdown">
        <button class="dropdown-btn">
            {{ selectedLabel }}
            <span class="arrow" :class="{ open: isOpen }"> <i class="el-icon-arrow-down el-icon--right"></i> </span>
        </button>

        <ul v-if="isOpen" class="dropdown-list">
            <li v-for="(item, index) in options" :key="index" class="dropdown-item" @click.stop="selectItem(item)">
                {{ item.label }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "DropdownMenu",
    props: {
        options: {
            type: Array,
            required: true
        },
        defaultLabel: {
            type: String,
            default: "请选择"
        }
    },
    data() {
        return {
            isOpen: false,
            selectedLabel: this.defaultLabel
        };
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectItem(item) {
            this.selectedLabel = item.label;
            this.isOpen = false;
            this.$emit("select", item);
        }
    },
    mounted() {
        document.addEventListener("click", this.closeDropdown);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeDropdown);
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        selectItem(item) {
            this.selectedLabel = item.label;
            this.isOpen = false;
            this.$emit("select", item);
        },
        closeDropdown() {
            this.isOpen = false;
        }
    }
};
</script>

<style scoped>
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-btn {
    padding: 8px 12px;
    border: none ;
    background: #fff;
    cursor: pointer;
    border-radius: 4px;
}

.arrow {
    margin-left: 8px;
    transition: transform 0.3s;
}

.arrow.open {
    transform: rotate(180deg);
}

.dropdown-list {
    position: absolute;
    top: 110%;
    left: 0;
    min-width: 120px;
    max-height: 48vh;
    overflow: scroll;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    list-style: none;
    padding: 4px 0;
    margin: 0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    z-index: 1000;
}

.dropdown-item {
    padding: 8px 12px;
    cursor: pointer;
}

.dropdown-item:hover {
    background: #f5f5f5;
}
</style>
